// extracted by mini-css-extract-plugin
export default {"coverWrapper":"ESNOXa","cover":"Fq1hlj","thumbContainer":"mdGBQR","thumbWrapper":"ZHR2PW"};